import PlatformDashboard from "layouts/dashboard";
import TenantList from "layouts/tenants/tenant-list";
import TenantCreate from "layouts/tenants/tenant-create";
import TenantEdit from "layouts/tenants/tenant-edit";
import TenantDashboard from "layouts/tenants/tenant-dashboard";
import UserList from "layouts/users/user-list";
import UserCreate from "layouts/users/user-create";
import UserEdit from "layouts/users/user-edit";
import TOSManage from "layouts/tos/manage";
import SalesLeadList from "layouts/sales-leads/sales-leads-list";
import SalesLeadCreate from "layouts/sales-leads/sales-leads-create";
import SalesLeadEdit from "layouts/sales-leads/sales-leads-edit";
import PilotApprovals from "layouts/pilot-approvals";

import SpaceShip from "examples/Icons/SpaceShip";
import Shop from "examples/Icons/Shop";
import CustomerSupport from "examples/Icons/CustomerSupport";
import SettingsIcon from "examples/Icons/Settings";
import Office from "examples/Icons/Office";
import Document from "examples/Icons/Document";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <SpaceShip size="12px" />,
    route: "/dashboard",
    component: <PlatformDashboard />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Tenants",
    key: "tenants",
    icon: <Shop size="12px" />,
    collapse: [
      {
        name: "All Tenants",
        key: "tenant-list",
        route: "/tenants",
        component: <TenantList />,
      },
      {
        name: "Create Tenant",
        key: "tenant-create",
        route: "/tenants/create",
        component: <TenantCreate />,
      },
      {
        name: "Edit Tenant",
        key: "tenant-edit",
        route: "/tenants/edit/:tenantId",
        component: <TenantEdit />,
        hidden: true,
      },
      {
        name: "Tenant Dashboard",
        key: "tenant-dashboard",
        route: "/tenants/dashboard/:tenantId",
        component: <TenantDashboard />,
        hidden: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <CustomerSupport size="12px" />,
    collapse: [
      {
        name: "All Users",
        key: "user-list",
        route: "/users",
        component: <UserList />,
      },
      {
        name: "Create User",
        key: "user-create",
        route: "/users/create",
        component: <UserCreate />,
      },
      {
        name: "Edit User",
        key: "user-edit",
        route: "/users/edit",
        component: <UserEdit />,
        hidden: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Sales Leads",
    key: "sales-leads",
    icon: <Office size="12px" />,
    collapse: [
      {
        name: "All Sales Leads",
        key: "sales-leads-list",
        route: "/sales-leads",
        component: <SalesLeadList />,
      },
      {
        name: "Create Sales Lead",
        key: "sales-leads-create",
        route: "/sales-leads/create",
        component: <SalesLeadCreate />,
      },
      {
        name: "Edit Sales Lead",
        key: "sales-leads-edit",
        route: "/sales-leads/edit",
        component: <SalesLeadEdit />,
        hidden: true,
      },
    ],
  },
  {
    type: "collapse",
    name: "Pending Approvals",
    key: "pilot-approvals",
    icon: <Document size="12px" />,
    route: "/pilot-approvals",
    component: <PilotApprovals />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Terms of Service",
    key: "tos",
    icon: <SettingsIcon size="12px" />,
    route: "/tos",
    component: <TOSManage />,
    noCollapse: true,
  },
];

export default routes;
